import Factory from '../utils/factory'
import Address from '../Address'
import Sale from './sale'
import Shared from '../ResidentialTemplate/shared'

export default Factory({
  id: null,
  number: null,
  displayName: null,
  status: 'draft',
  cadastre: null,
  redirectUrl: null,
  sale: Sale(),
  address: Address(),
  owners: null,
  reservedBy: null,
  customFields: null,
  customFieldsConfig: [],
  ...Shared(),
})
